// extracted by mini-css-extract-plugin
module.exports = {"vocabularyInfo":"VocabularyInfo_vocabularyInfo__39vPY","kk":"VocabularyInfo_kk__u4UCu","partOfSpeech":"VocabularyInfo_partOfSpeech__3l-sy"};